/*global angular */

(function (angular) {
'use strict';

var timeline = angular.module('timeline', [
    'infinite-scroll',
    'ngCookies',
    'ngSanitize',
    'timeline.services',
    'timeline.filters',
    'timeline.directives',
    'timeline.controllers',
]);

timeline.constant('Types', {
    review: 18,
    comment: 41,
    quote: 20,
    topic: 61,
    fact: 89,
    book: 13,
    bookcomment: 111
});

timeline.constant('Genders', {
    female: 0,
    male: 1,
    nogender: -1
});

timeline.constant('reviewMinLength', 800);
timeline.constant('shortTextLength', 500);

timeline.constant('reviewTypes', {
    positive: 1,
    negative: -1,
    neutral: 0
});

timeline.constant('topicTypes', {
    forAll: 0,
    forSubscribers: 1
});

timeline.constant('commentsLoaded', 3);
}(angular));
